import React from "react";
import { Helmet } from "react-helmet-async";

/**
 * Page-level SEO component.
 * Usage: <SEO title="..." description="..." image="..." canonical="..." />
 * Falls back to sane defaults for the Biscayne Quilt Supply storefront.
 */
const DEFAULTS = {
  title: "Biscayne Quilt Supply — Quilting & Sewing Supplies, Made for Makers",
  description: "US-based online shop for quilting and sewing supplies — fabric, rulers, cutting mats, threads, notions, and patterns. Curated by makers, for makers. Free US shipping over $75.",
  image: "https://images.unsplash.com/photo-1626784579980-db39c1a13aa9?w=1200&auto=format&fit=crop&q=80",
  siteName: "Biscayne Quilt Supply",
};

export default function SEO({
  title,
  description,
  image,
  canonical,
  type = "website",
  noindex = false,
  keywords,
}) {
  const fullTitle = title ? `${title} — Biscayne Quilt Supply` : DEFAULTS.title;
  const desc = description || DEFAULTS.description;
  const img = image || DEFAULTS.image;
  const href = canonical || (typeof window !== "undefined" ? window.location.href : "");

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {keywords && <meta name="keywords" content={keywords} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      {canonical && <link rel="canonical" href={canonical} />}

      {/* Open Graph */}
      <meta property="og:site_name" content={DEFAULTS.siteName} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      {img && <meta property="og:image" content={img} />}
      {href && <meta property="og:url" content={href} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {img && <meta name="twitter:image" content={img} />}
    </Helmet>
  );
}
